import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Grid, Box, Typography, Divider,CircularProgress } from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import RawdemandInfo from '../RawdemandInfo';
import ProductrawDashboard from 'components/productraw/ProductrawDashboard';
import ProductrawListTable from 'components/productraw/components/ProductrawListTable';
import { selectVendorAPI, deselectVendorAPI } from 'api/OmsOrdermgmtWebServices';
import { updateRawdemandObj } from 'store/slice/PharmaSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';


export default function RawdemandListTableRow({ obj, getActionComponent, handleRowClick }) {
  const dispatch = useDispatch();

  const { productrawList } = useSelector((state) => state.pharmaslice);
  const { rmvendorquotationList } = useSelector((state) => state.pharmaslice);
  const {rawdemandObj} = useSelector((state)=>state.pharmaslice.rawdemandDashboard);
  const {rawdemandList} = useSelector((state)=>state.pharmaslice);
  const {apiInProgress} = useSelector((state)=>state.headerslice);
  useEffect(() => {

  }, [productrawList, apiInProgress])

  const getProductRawByRMid = (rmId) => {
    return productrawList.filter(productrawObj => productrawObj.rmid === rmId && productrawObj.status==="DEMANDED")
  }
  const getVendorQuotation = (demandId) => {
    return rmvendorquotationList.filter(demandObj => demandObj.rawdemandid === demandId)
  }
  const selectVendorFailureCallBack = (obj) =>{
    dispatch(setApiInProgress(false));
    alert("ERROR: "+obj);
  }
  const selectVendorSuccessCallBack = (responseObj) =>{
    dispatch(setApiInProgress(false));
    dispatch(updateRawdemandObj(responseObj.rawdemandInfo))
  }
  const selectVendor = (rawdemandid, vendorid) =>{
    dispatch(setApiInProgress(true));
    selectVendorAPI({
      "demandId":rawdemandid,
      "vendorId":vendorid
    }, selectVendorSuccessCallBack, selectVendorFailureCallBack)
  }
  const deselectVendor = (rawdemandid) =>{
    dispatch(setApiInProgress(true));
    selectVendorAPI({
      "demandId":rawdemandid
    }, selectVendorSuccessCallBack, selectVendorFailureCallBack)
  }

  const handleClickOnVendor = (quotationObj) =>{

    console.log('quotationObj=>'+JSON.stringify(quotationObj))
    

    let rawdemandidIndex = rawdemandList.findIndex(demandObj => demandObj.id === quotationObj.rawdemandid);
    let rawdemandidObj = rawdemandList[rawdemandidIndex];
    console.log("rawdemandidObj=>"+JSON.stringify(rawdemandidObj))
    console.log("rawdemandidObj.vendorid==>"+typeof rawdemandidObj.vendorid);
    console.log("quotationObj.rmvendorid==>"+typeof quotationObj.rmvendorid);

    console.log("result =>"+rawdemandidObj.vendorid==quotationObj.rmvendorid);
    if (rawdemandidObj.vendorid===0){
      // vendor is not selected then select clicked vendor
      selectVendor(quotationObj.rawdemandid, quotationObj.rmvendorid);
    
    } else if (rawdemandidObj.vendorid!==0 && parseInt(rawdemandidObj.vendorid)===parseInt(quotationObj.rmvendorid)){
      // vendor is already selected but clicked on is same than deselect clicked vendor
      deselectVendor(quotationObj.rawdemandid);

    }else if (rawdemandidObj.vendorid!==0 && rawdemandidObj.vendorid!==quotationObj.rmvendorid){
      // vendor is already selected but clicked on is different than earlier selected then select clicked vendor
      selectVendor(quotationObj.rawdemandid, quotationObj.rmvendorid);
    
    } 
  }

  const vendorSelected = (quotationObj) =>{
    let rawdemandidIndex = rawdemandList.findIndex(demandObj => demandObj.id === quotationObj.rawdemandid);
    let rawdemandidObj = rawdemandList[rawdemandidIndex];

    if (rawdemandidObj.vendorid!==0 && rawdemandidObj.vendorid===quotationObj.rmvendorid){
      return true;
    }
    return false;

  }
  return (

    <>
      <Grid item lg={12} sx={{ width: '100%' }}>
        {/* <ROW1 - CONTAINER/> */}
        <Grid container direction="row" onClick={() => handleRowClick(obj.id)}
          sx={{
            cursor: 'pointer',
            justifyContent: "flex-start", alignItems: "center", padding: 1, backgroundColor: obj.expand ? 'primary.200' : 'white',
            '&:hover': {
              backgroundColor: 'secondary.lighter', color: 'primary.main'
            },
          }}>
          {/* <ROW1 - CELLS/> */}

          <Grid item lg={4} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.title}</Typography></Grid>
          <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.qty}&nbsp;{obj.unit}</Typography></Grid>
          <Grid item lg={4} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.vendorname}</Typography></Grid>
          {/* <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.unit}</Typography></Grid> */}
          {/* <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.status}</Typography></Grid> */}

          <Grid item lg={2} xs={2} >
            <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
              {getActionComponent(obj)}
            </Grid>
          </Grid>

        </Grid>
      </Grid>
      {obj.expand ?
        <Grid container direction="row" sx={{ backgroundColor: '#fafafa' }}>
          <Grid item lg={6} sx={{ padding: 1, }}>
            
              <Grid container direction="row" sx={{ borderRight: '1px solid #69c0ff' }}>
                {
                  getProductRawByRMid(obj.rmid).map(productRawObj => {
                    return (
                      <Grid item  lg={12}><FieldView label={productRawObj.productname} value={productRawObj.qty} /></Grid>
                    )
                  })
                }
              </Grid>
          </Grid>
          <Grid item lg={6} sx={{ padding: 1, }}>
            <Grid container direction="row"  alignItems='center' sx={{ alignItems:'center'}}>
              {
                apiInProgress?<CircularProgress/>:
                getVendorQuotation(obj.id).map(quotationObj => {
                  return (
                    <Grid item lg={6} sx={{
                        cursor:'pointer',
                        '&:hover': {
                          color: 'primary.main'
                        }
                      }} onClick={()=>handleClickOnVendor(quotationObj)}>
                        <Grid sx={{padding:1, backgroundColor: vendorSelected(quotationObj)?'primary.200':'',}}>
                          <FieldView label={quotationObj.rmvendorname} value={quotationObj.quotation} />
                        </Grid>

                      
                    </Grid>
                  )
                })
              }
            </Grid>
          </Grid>

          <Grid item lg={12} sx={{ padding: .10, backgroundColor: 'primary.200' }}>

          </Grid>
        </Grid>

        : <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>}
    </>

  )
}